import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { useImagesViewerStates, ImageFile } from "@/features/accounts/ocr/hooks/use-images-viewer-states";
import { GetImagesService } from "@/features/accounts/ocr/services/get-images-service";
import { PutImagesService } from "@/features/accounts/ocr/services/put-images-service";
import { useContext } from "react";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";


export const useImageViewer = () => {
  const {
    imagesList,
    setImagesList,
  } = useImagesViewerStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);

  const getImagesService = new GetImagesService();
  const putImagesService = new PutImagesService();

  /*--------------------
    イベント関連
  --------------------*/
    // OCR読み取り画像の管理↓↓
    const buildDraftKey = (
      ocrAccountId: string,
      ocrProcessId: string,
    ) => {
      return `ocr_draft_${ocrAccountId}_${ocrProcessId}_images`;
    };
  
    // const loadDraft = (key: string) => {
      // const raw = localStorage.getItem(key);
      // if (raw) {
        // return JSON.parse(raw);
      // }
    // };
  
    const saveDraft = (key: string, data: ImageFile[] | undefined) => {
      localStorage.setItem(key, JSON.stringify(data));
    };
  // OCR読み取り画像の管理↑↑
  
  // 画像一覧取得
  const setImages = async (
    accountGroupId: string,
    ocrAccountId: string,
    ocrProcessId?: string,
    tradeId?: string,
  ) => {
    loadingCtx.setIsLoading(true);

    try {
      const res = await getImagesService.GetImages({
        account_group_id: accountGroupId,
        ocr_account_id : ocrAccountId,
        ... (ocrProcessId !== undefined && { ocr_process_id: ocrProcessId}),
        ... (tradeId !== undefined && { trade_id: tradeId})
      });

      const images: ImageFile[] = res.map((img) => ({
        filename: img.file_name,
        originFilename: img.origin_file_name,
        url: img.image_url,
        isCompleted:  img.is_status === 0 ? false : true,
      }));

      setImagesList(images);

      // 別端末で画像状態が更新されている可能性があるため，その情報を持つためにlocalstorage保存は存続
      if (images.length > 0 && !tradeId && ocrProcessId) {
        saveDraft(buildDraftKey(ocrAccountId, ocrProcessId), images);
      }
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("getImages", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

    // 画像情報更新(画像ごと削除時)
  const cancelImage = async (
    accountGroupId: string,
    ocrAccountId: string,
    ocrProcessId: string,
    file_name: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putImagesService.putImages({
        account_group_id: accountGroupId,
        ocr_account_id : ocrAccountId,
        ocr_process_id: ocrProcessId,
        file_name: file_name,
      });
      
    } catch (error) {
      // エラーハンドリング
      console.log("putImages", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    imagesList,
    setImages: errorHandledSync(setImages, setError),
    cancelImage: errorHandledSync(cancelImage, setError),
  };
};
